import { gql } from 'graphql-request'

export namespace TaskTypesQueries {
  export namespace GET_TASKTYPES {
    export type Response = { followUpTaskTypes: FollowUpTaskType[] | null }
  }
  // Explicit string — do not use getTaskTypes.name; minification mangles it
  export const QUERY_KEY = 'getFollowUpTaskTypes'
  export function getTaskTypes() {
    return gql`
      query getFollowUpTaskTypes($filter: FollowUpTaskTypeFilter = { active: true }) {
        followUpTaskTypes(filter: $filter) {
          id
          description
        }
      }
    `
  }
}

export interface FollowUpTaskType {
  description: string
  id: number
}
